module.exports = __webpack_public_path__ + "static/media/project-completed.ad0028b4.svg";